import { withContext } from 'admin/components/common/withContext'
import WindowTitle from 'components/ui/WindowTitle'

export default withContext(WindowTitle)